import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';
import Modal from 'common/components/ModalComponent';
import { updateMandatoryPreferences, signOut } from 'common/api/user';
import { LANGUAGES } from './constants';

const propTypes = {
  redirectPath: PropTypes.string.isRequired,
};

const Preferences = ({ redirectPath }) => {
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [isInterestedInDemo, setIsInterestedInDemo] = useState(undefined);
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!selectedLanguages.length || isInterestedInDemo === undefined) {
      setError('Please fill all the fields');
      return;
    }

    setError('');

    updateMandatoryPreferences({
      comfortable_languages: selectedLanguages,
      is_interested_in_demo: isInterestedInDemo,
    }).then((res) => {
      if (res.status) {
        window.location.href = redirectPath;
      } else {
        setError('Something went wrong');
      }
    });
  };

  return (
    <Modal size="md" onClose={signOut} className="email-verification">
      <form className="select-language-container">
        <div className="form-group text-center m-auto">
          <label htmlFor="languages">Select your preferred Languages:</label>
          <Typeahead
            id="languages"
            multiple
            options={LANGUAGES}
            selected={selectedLanguages}
            onChange={setSelectedLanguages}
            className="fixed-width-multiselect"
          />
        </div>

        <div className="form-group text-center m-auto">
          <label>
            Are you interested in attending a <b>demo</b> of Quantman?
          </label>
          <div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="demo-interest"
                id="demo-interest-yes"
                checked={isInterestedInDemo === true}
                onChange={() => setIsInterestedInDemo(true)}
              />
              <label className="form-check-label" htmlFor="demo-interest-yes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="demo-interest"
                id="demo-interest-no"
                checked={isInterestedInDemo === false}
                onChange={() => setIsInterestedInDemo(false)}
              />
              <label className="form-check-label" htmlFor="demo-interest-no">
                No
              </label>
            </div>
          </div>
        </div>

        {error && <p className="text-center text-danger">{error}</p>}

        <div className="text-center">
          <button type="button" className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </form>
    </Modal>
  );
};

Preferences.propTypes = propTypes;

export default Preferences;
